import React, {Component} from "react";
import DissimilarCharacteristics from "./DissimilarCharacteristics";

export default class DissimilarCategories extends Component {
    render() {
        return (<DissimilarCharacteristics showCategory={true} {...this.props} />);
    }
}
